// @oasis-permission-inherits: /videos (mirage-videos:view)
import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";
import { PreferenceTrainingAdminPage } from "~/modules/segment-review/components/preference-training-admin-page";

export const Route = createFileRoute("/_dash/videos/segment-eval/admin")({
  beforeLoad() {
    ensureSession();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PermissionGuard permission="mirage-videos:view">
      <PreferenceTrainingAdminPage />
    </PermissionGuard>
  );
}
